export interface CompanyState {
  companyList: any[]
  companyListPage: number
  companyListFetching: boolean
  companyListError: string | undefined
  companySorting: {
    // TODO: Why aren't we exporting SortDirection from ui-utils?
    [key: string]: 'ASC' | 'DESC'
  }
  racFilter: {
    green: boolean | undefined
    yellow: boolean | undefined
    red: boolean | undefined
  }
  companyMap: any[]
  currentCompany: any | undefined
  companyWatcher: boolean
  gicsList: any[]
  cashSourceList: any[]
  terminalNavigationVisible: boolean
  newIssuesOnly: boolean | undefined
  filter: string | undefined
  companyUiInfo: { [key: string]: any }
  historyList: any[]
  mostViewedList: any[]
  nextReportingList: any[]
  lastReportedList: any[]
  companyListCount: { [key: string]: number }
  searchParam: string | undefined
  memoStructureList: any[]
  recentDocuments: any[]
  searchSuggestions: any[]
  earningsSummary: any | undefined
  showWatchlistTooltip: string | undefined
}

export default {
  companyList: [],
  companyListPage: 1,
  companyListFetching: false,
  companyListError: undefined,
  companySorting: {
    name: 'ASC',
  },
  racFilter: {
    green: undefined,
    yellow: undefined,
    red: undefined,
  },
  companyMap: [],
  currentCompany: undefined,
  companyWatcher: false,
  gicsList: [],
  cashSourceList: [],
  terminalNavigationVisible: false,
  newIssuesOnly: undefined,
  filter: undefined,
  companyUiInfo: {},
  historyList: [],
  mostViewedList: [],
  nextReportingList: [],
  lastReportedList: [],
  companyListCount: {},
  searchParam: undefined,
  memoStructureList: [],
  recentDocuments: [],
  searchSuggestions: [],
  earningsSummary: undefined,
  showWatchlistTooltip: undefined,
} satisfies CompanyState
